import { css } from "@emotion/css";
import { PopoverBasicHelp } from "@octopusdeploy/design-system-components";
import { space, text, themeTokens, borderRadius } from "@octopusdeploy/design-system-tokens";
import { LicenseMessageDisposition } from "@octopusdeploy/octopus-server-client";
import React from "react";
import CircularProgressLicenseUsage from "./CircularProgressBar";
import { InfinityIcon } from "./InfinityIcon";
type UsageCardProps = {
    title: string;
    subtitle: string;
    percentage: number;
    disposition: LicenseMessageDisposition;
    isUnlimited?: boolean;
    contextualHelp?: React.ReactNode;
};
export function UsageCard({ title, subtitle, percentage, disposition, contextualHelp, isUnlimited = false }: UsageCardProps) {
    const circularProgressBarUrgency = findUrgency(disposition);
    return (<div className={style.cardWrapper}>
            <div className={style.usageVisualisation}>{isUnlimited ? <InfinityIcon color={themeTokens.color.icon.info}/> : <CircularProgressLicenseUsage circularProgressBarUrgency={circularProgressBarUrgency} percentage={percentage}/>}</div>
            <div className={style.usageTextContainer}>
                <div className={style.name}>
                    {title} {contextualHelp && <PopoverBasicHelp description={contextualHelp} placement={"right-start"}/>}
                </div>
                <div className={style.usageDisplay}>{subtitle}</div>
            </div>
        </div>);
}
function findUrgency(disposition: LicenseMessageDisposition) {
    switch (disposition) {
        case LicenseMessageDisposition.Error:
        case LicenseMessageDisposition.Warning:
            return "danger";
        case LicenseMessageDisposition.Notice:
            return "warning";
        default:
            return "info";
    }
}
const style = {
    cardWrapper: css({
        padding: space[16],
        borderRadius: borderRadius.large,
        boxShadow: themeTokens.shadow.extraSmall,
        backgroundColor: themeTokens.color.card.background.primary.default,
        display: "flex",
        alignItems: "flex-start",
        minWidth: "214px",
        maxHeight: space[80],
        gap: space[12],
        width: "100%",
        "& img": {
            width: "38px",
        },
    }),
    usageVisualisation: css({
        width: "48px",
        aspectRatio: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    }),
    usageTextContainer: css({
        display: "flex",
        flexDirection: "column",
        gap: space[4],
        alignItems: "flex-start",
    }),
    name: css({
        font: text.body.regular.medium,
        color: themeTokens.color.text.secondary,
    }),
    usageDisplay: css({
        font: text.body.bold.large,
    }),
};
